module.exports = __webpack_public_path__ + "static/media/edit_blue.8390a64e.svg";